/** Preliminary-not-for-issuance stamp banner (QOE-RECON-1 — extracted from
 *  EntityStructurePage.tsx to clear the FILE_SIZE_POLICY.md 400-line
 *  threshold). Rendered at the top of the page (before anyone runs anything)
 *  and again directly above the consolidated figures, so neither the page
 *  nor a screenshot of the table can travel without it. Wording is whatever
 *  the backend sends; the fallback only covers an older API that predates
 *  the stamp. */
import { ShieldAlert } from 'lucide-react'
import type { PreliminaryStamp } from '@/api/client'

export default function PreliminaryStampBanner({ stamp }: { stamp?: PreliminaryStamp }) {
  if (stamp && !stamp.not_for_client_issuance) return null
  const label =
    stamp?.label ??
    'Preliminary — not for client issuance; consolidation logic under CPA review.'
  const methodNote = stamp?.method_note ?? 'Method pending CPA confirmation.'
  return (
    <div
      role="alert"
      data-testid="consolidation-preliminary-stamp"
      className="flex items-start gap-2 p-3 bg-red-50 border-2 border-red-300 rounded text-sm text-red-800"
    >
      <ShieldAlert className="w-5 h-5 flex-shrink-0 mt-0.5" />
      <div>
        <p className="font-semibold uppercase tracking-wide text-xs">
          Preliminary — not for client issuance
        </p>
        <p className="mt-1">{label}</p>
        <p className="mt-1 text-xs">
          {methodNote} Report generation and download are blocked for deals with more
          than one entity until the consolidation logic is corrected and signed off.
        </p>
      </div>
    </div>
  )
}
